import React, { useEffect, useState, useCallback } from "react";
import { getBrand, deleteBrand } from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { EditBrands } from "./Form";
import { Deletemodel } from "../../Common/Functions";

const Brand = () => {
  const [brands, setBrands] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [isAddMode, setIsAddMode] = useState(true); // Add or Edit flag
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages,setTotalPages]=useState(0);
  const [deleteID, setDeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);
  const brandsPerPage = 10;

  // Fetch brands from API
  const fetchBrands = useCallback(async (page=1,text="") => {
    try {
      const response = await getBrand(page,text);
      if (response.data?.data) {
        setBrands(response.data.data);
        setTotalPages(response.data.pagination.total_pages); // Update total pages for pagination
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
      toast.error("Error fetching brands");
    }
  }, []);

  useEffect(() => {
    fetchBrands();
  }, []);


  const handledeletemodel = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  }

  const openAddModal = () => {
    setIsAddMode(true);
    setSelectedBrand(null); // Reset selected brand when adding a new one
    setShowEditModal(true);
  };

  const openEditModal = (brand) => {
    setSelectedBrand(brand);
    setIsAddMode(false); // Set to edit mode
    setShowEditModal(true);
  };

  const   handleDelete = async () => {
    try {
      await deleteBrand(deleteID);
      toast.success("Brand deleted successfully");
      fetchBrands(); // Re-fetch brands after deletion
      showDeletemodel(false)
    } catch (error) {
      console.error("Error deleting brand:", error);
      toast.error("Error deleting brand");
    }
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchBrands(pageNumber);
  };

  const handleSearch = async (text)=>{
    fetchBrands(1,text)
  }

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <h6 className="mb-0 text-uppercase">Brand List</h6>
        <hr />
        <button
          type="button"
          onClick={openAddModal}
          className="btn btn-primary mb-2 text-normal rounded-1"
        >
          Add Brand
        </button>

        <div className="card h-100">
          <div className="card-body">
          <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                    <div className="d-flex position-relative" style={{ width: "100%" }}>
                        <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search..."
                        onChange={(e) => handleSearch(e.target.value)}
                        />
                        <img
                        src="/assets/images/icons/search.png"
                        alt="Search Icon"
                        style={{
                            position: "absolute",
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            height: "18px",
                            pointerEvents: "none",
                        }}
                        />
                    </div>
                    </div>
            <div className="table-responsive">
              <table
                id="example"
                className="table table-striped  table-sm table-bordered"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Brand Name</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {brands.length > 0 ? (
                    brands.map((brand, index) => {
                      const {
                        brand_id,
                        name,
                        manufacturer_name,
                      } = brand;
                      return (
                        <tr key={brand_id}>
                          <td>
                            {(currentPage - 1) * brandsPerPage + index + 1}
                          </td>
                          <td>{name}</td>

                          <td>
                            <img src='/assets/images/icons/edit.png' onClick={() => openEditModal(brand)} height={"16px"} />
                            &nbsp;&nbsp;&nbsp;
                            <img src='/assets/images/icons/delete.png' className="mx-1" onClick={() => handledeletemodel(brand_id)} height={"16px"} />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No brands found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination controls */}
              <div className="pagination mb-1">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  className={`page-link text-normal rounded-1 ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => handlePageChange(index + 1)}
                    className={`page-link text-normal rounded-1 ${
                      currentPage === index + 1 ? "active" : ""
                    }`}
                  >
                    {index + 1}
                  </button>
                ))}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  className={`page-link text-normal rounded-1 ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      {/* Modal for editing or adding brand */}
      <EditBrands
        showModal={showEditModal}
        setShowModal={setShowEditModal} x
        fetchBrands={fetchBrands}
        selectedBrand={selectedBrand}
        isAddMode={isAddMode}
      />
    </div>
  );
};

export default Brand;
